<template>
  <span class="c-progress-bar">RUSI Proliferation Financing Risk Exercise:
    {{ step }} / {{ this.$store.state.totalSteps }}</span>
</template>

<style lang="scss" src="@/assets/sass/components/progress-bar.scss"></style>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
};
</script>
